var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Renderer2, AfterViewInit } from '@angular/core';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { ModalService } from 'hsg';
import { AuthUserService } from '../auth-user.service';
import { AuthenticationStatus } from '../enums/enums';
var AuthStrictIdChoiceComponent = /** @class */ (function (_super) {
    __extends(AuthStrictIdChoiceComponent, _super);
    function AuthStrictIdChoiceComponent(renderer, modalService, authService) {
        var _this = _super.call(this, modalService, authService) || this;
        _this.renderer = renderer;
        _this.modalService = modalService;
        _this.authService = authService;
        _this.selectedTab = 0;
        _this.minDate = new Date(1948, 4, 14);
        _this.maxDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
        _this.date = { day: '', month: '', year: '' };
        _this.cardNumberModal = '';
        _this.cvvModal = '';
        _this.issueDate = { day: '', month: '', year: '' };
        _this.data = {};
        _this.inputs = null;
        _this.serverError2 = null;
        return _this;
    }
    AuthStrictIdChoiceComponent.prototype.onKeyDown = function (e) {
        var date = new Date(parseInt(this.issueDate.year), parseInt(this.issueDate.month) - 1, parseInt(this.issueDate.day));
        this.isValidIssueDate = date.getDate() == parseInt(this.issueDate.day) &&
            date.getMonth() + 1 == parseInt(this.issueDate.month) &&
            date.getFullYear() == parseInt(this.issueDate.year) &&
            date >= this.minDate && date < this.maxDate;
        if (this.selectedTab == 1 && e.srcElement.maxLength != null && e.srcElement.maxLength === e.srcElement.value.length) {
            e.preventDefault();
            var index = parseInt(e.srcElement.getAttribute('data-index'));
            if (this.inputs == null)
                this.inputs = this.inputsQuery.map(function (elm) { return elm.elementRef.nativeElement; });
            if (index == this.inputs.length - 1) {
                document.querySelector('button').focus();
            }
            else {
                this.inputs[++index].focus();
            }
        }
    };
    AuthStrictIdChoiceComponent.prototype.elasticLogit = function () {
        this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2150' })
            .subscribe(function (res) { return console.log("sent elasticLog code:2150 - open window", res); }, function (error) { return console.log("sent elasticLog - open window error!", error); });
    };
    AuthStrictIdChoiceComponent.prototype.ngOnInit = function () {
        this.elasticLogit();
        sessionStorage.setItem("currentWindow", "חלונית זיהוי מפוצלת");
        sessionStorage.setItem("elasticCode", "2948");
        this.data = this.modalService.data;
        this.isShowContactLink = this.shouldContactLink('authStrictChoice');
    };
    AuthStrictIdChoiceComponent.prototype.ngAfterViewInit = function () {
        var element = this.renderer.selectRootElement('#cardnumber');
        setTimeout(function () { return element.focus(); }, 0);
    };
    AuthStrictIdChoiceComponent.prototype.submitCreditCard = function (form) {
        var _this = this;
        var element = this.inputsQuery.map(function (elm) { return elm.elementRef.nativeElement; }).find(function (elm) { return elm.classList.contains('ng-invalid'); });
        if (element) {
            element.setAttribute('aria-invalid', true);
            setTimeout(function () { return element.focus(); }, 0);
        }
        if (form.valid && this.isValidDate) {
            this.pending = true;
            this.serverError = null;
            form.value.cardnumber.replace(' ', '');
            var card = {
                creditCardDetails: {
                    CardNum: form.value.cardnumber.trim(),
                    Month: form.value.month,
                    Year: form.value.year,
                    CVV: form.value.cvv
                }
            };
            //console.log("sent parametes", card);
            this.authUserService.sendAuthData("ValidateCreditCard", card)
                .subscribe(function (res) {
                if (res.Status == AuthenticationStatus.Failure && res.Details.UserInputError == "InvalidCreditCard") {
                    _this.elasticLogit();
                    _this.serverError = "פרטי האשראי שהוקלדו אינם תקינים או שאינו רשום על שמך. יש לבדוק ולנסות שוב.";
                }
                else if (res.Status == AuthenticationStatus.Failure && res.Details.UserInputError == "InvalidCreditCardTech") {
                    _this.elasticLogit();
                    _this.serverError = "אירעה תקלה באימות פרטי כרטיס האשראי שלך. אנו מטפלים בתקלה. יש לנסות שוב במועד מאוחר יותר.";
                }
                else {
                    _this.modalService.close(res.Details);
                }
            }, function () { return _this.pending = false; }, function () { return _this.pending = false; });
        }
        this.buildFormAccessibility();
    };
    AuthStrictIdChoiceComponent.prototype.submitIssueDate = function (form) {
        var _this = this;
        var element = this.inputsQuery.map(function (elm) { return elm.elementRef.nativeElement; }).find(function (elm) { return elm.classList.contains('ng-invalid'); });
        if (element) {
            element.setAttribute('aria-invalid', true);
            setTimeout(function () { return element.focus(); }, 0);
        }
        if (form.valid && this.isValidIssueDate) {
            this.pending = true;
            this.serverError2 = null;
            //console.log("sent parametes", { ClientInsertedIdIssueDate: date });
            this.authUserService.sendAuthData("ValidateIdIssueDate", { year: parseInt(this.issueDate.year), month: parseInt(this.issueDate.month), day: parseInt(this.issueDate.day) })
                .subscribe(function (res) {
                if (res.Status == AuthenticationStatus.Failure && res.Details.UserInputError == "InvalidIssueDate") {
                    _this.elasticLogit();
                    _this.serverError2 = "תאריך הנפקת תעודת הזהות אינו מתאים. אנא נסו שוב.";
                }
                else {
                    _this.modalService.close(res.Details);
                }
            }, function () { return _this.pending = false; }, function () { return _this.pending = false; });
        }
        this.buildFormAccessibility();
    };
    AuthStrictIdChoiceComponent.prototype.validateDate = function () {
        this.isValidDate = new Date().getMonth() + 1 <= parseInt(this.date.month) &&
            new Date().getFullYear() == parseInt("20" + this.date.year) || new Date().getFullYear() < parseInt("20" + this.date.year);
    };
    // validateIssueDate() {
    //   let date = new Date(parseInt(this.issueDate.year), parseInt(this.issueDate.month) - 1, parseInt(this.issueDate.day));
    //   this.isValidDate = date.getDate() == parseInt(this.date.day) &&
    //     date.getMonth() + 1 == parseInt(this.date.month) &&
    //     date.getFullYear() == parseInt(this.date.year) &&
    //     date >= this.minDate && date < this.maxDate;
    //   //console.log(this.isValidDate);
    // }
    AuthStrictIdChoiceComponent.prototype.selectTab = function (index) {
        this.selectedTab = index;
        this.inputs = null;
        return false;
    };
    return AuthStrictIdChoiceComponent;
}(AuthBaseComponent));
export { AuthStrictIdChoiceComponent };
